import { create } from 'mutative';
import { isFunction } from '../../utils';
import { LOGOUT_DONE } from '../Auth/constants';
import {
  ACTION_RESOLVED,
  GET_ENTITY,
  GET_LIST,
  SAVE_ENTITY,
  UPDATE_ENTITY,
} from './constants';

export const initialState = {
  branches: [],
  brands: [],
  categories: [],
  checkedCategories: [],
  checkedItems: [],
  isLoading: false,
  isLoadingProfiles: false,
  isSaving: false,
  items: [],
  itemSearchKey: '',
  menus: [],
  profiles: [],
  selectedBranch: null,
  selectedBrand: null,
  selectedBusiness: null,
  selectedCategory: null,
  selectedFilterCategory: null,
  selectedFilterMenu: null,
  selectedProfile: null,
};

const reducer = (state = initialState, action) =>
  create(state, draft => {
    const actionParamKeys = Object.keys(action.meta || {});

    switch (action.type) {
      case UPDATE_ENTITY: {
        actionParamKeys.forEach(k => {
          const valOrCb = action.meta[k];
          if (isFunction(valOrCb)) {
            draft[k] = valOrCb(draft[k]);
          } else {
            draft[k] = valOrCb;
          }
        });
        break;
      }

      case GET_ENTITY:
      case GET_LIST:
      case SAVE_ENTITY:
        draft[action.meta?.loaderKey || 'isLoading'] = true;
        break;
      case ACTION_RESOLVED:
        draft[action.meta?.loaderKey || 'isLoading'] = false;
        break;

      case LOGOUT_DONE:
        initialState.forEach(key => {
          draft[key] = initialState[key];
        });
        break;

      default:
        break;
    }
  });
export default reducer;
